import React, { CSSProperties } from 'react';
import { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';

interface SvgProps {
  style?: CSSProperties;
}

function SvgPr(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse cx="7.99941" cy="5.5842" rx="5.58776" ry="5.58518" fill={'#F7D000'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7194 9.79869C12.5796 11.2534 10.8729 12.2431 8.93157 12.4355L10.5175 15.9997L12.212 13.1095L15.4143 13.6078L13.7194 9.79869ZM7.70376 12.4496C5.60242 12.2907 3.76166 11.1991 2.59478 9.58789L0.585724 13.6424L4.11011 13.1159L5.94768 15.9936L7.70376 12.4496Z"
        fill="#F7AB00"
      />
    </svg>
  );
}

const SvgErrorIcon = (props: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2" y="2" width="20" height="20" rx="10" fill="#E34B37" />
      <g clipPath="url(#clip0_2548_3744)">
        <path
          d="M15.182 8.81772L8.81802 15.1817M8.81802 8.81772L15.182 15.1817"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2548_3744">
          <rect width="12" height="12" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  );
};

interface ColoredIconProps {
  type: ColoredIconType;
  style?: CSSProperties;
}

export const ColoredIcon = (props: ColoredIconProps) => {
  return (
    <ThemeProvider theme={themeState.current}>
      <ColoredIcons {...props} style={{ width: 16, height: 16, ...props.style }} />
    </ThemeProvider>
  );
};

export type ColoredIconType = 'pr' | 'error';

const ColoredIcons = (props: ColoredIconProps) => {
  switch (props.type) {
    case 'pr':
      return <SvgPr />;
    case 'error':
      return <SvgErrorIcon />;
  }
};
